// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"951":"84a4928c","1310":"9b2f3d9d","1650":"6e3fcf45","1651":"84a4928c","2096":"84a4928c","4641":"84a4928c","5399":"84a4928c","7953":"9b2f3d9d"}[chunkId] + ".chunk.css";
};